import { useState } from 'react';
export default function useForceRender() {
    let fn;
    const [, setValue] = useState(() => {
        fn = () => setValue((value) => ++value);
        return 0;
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return fn;
}
//# sourceMappingURL=index.js.map